import { useState } from 'react'
import { Box, VStack, Text } from '@chakra-ui/react'
import { useGoogleLogin } from '@react-oauth/google'

const LoginScreen = () => {
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const login = useGoogleLogin({
    onSuccess: async ({ access_token }) => {
      setLoading(true)
      try {
        // Exchange the Google token for our own signed session cookie
        const res = await fetch('/api/auth/login', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ googleToken: access_token }),
          credentials: 'include',
        })
        if (!res.ok) throw new Error()
        const { name, email, picture, isAdmin } = await res.json()
        // Store display data only — isAdmin here is a UI hint; server enforces via cookie JWT
        localStorage.setItem('user', JSON.stringify({ name, email, picture, isAdmin }))
        window.location.reload()
      } catch {
        setError('Login failed. Please try again.')
        setLoading(false)
      }
    },
    onError: () => {
      setError('Google login failed. Please try again.')
      setLoading(false)
    },
  })

  return (
    <Box
      h="100vh"
      overflow="hidden"
      bgImage="url(/broldraskapet-logo-all-transparent-white.png)"
      bgSize="contain"
      bgRepeat="no-repeat"
      bgPosition={{ base: '50% 30%', md: '20% center' }}
      display="flex"
      alignItems={{ base: 'flex-end', md: 'center' }}
      justifyContent={{ base: 'center', md: 'flex-end' }}
      pb={{ base: '20vh', md: 0 }}
      pr={{ base: 0, md: '25%' }}
      position="relative"
    >
      <Box
        position="relative"
        zIndex={2}
        bg="whiteAlpha.100"
        backdropFilter="blur(10px)"
        borderRadius="xl"
        px={5}
        py={3}
        border="1px solid"
        borderColor="whiteAlpha.200"
        cursor={loading ? 'wait' : 'pointer'}
        transition="all 0.2s"
        _hover={{ bg: 'whiteAlpha.200' }}
        onClick={() => !loading && login()}
        userSelect="none"
      >
        <VStack spacing={1} textAlign="center">
          <Text fontSize="sm" color="whiteAlpha.600">Cheer in with</Text>
          <Text fontSize="3xl" fontWeight="bold" letterSpacing="wider">
            <span style={{ color: '#4285F4' }}>G</span>
            <span style={{ color: '#EA4335' }}>o</span>
            <span style={{ color: '#FBBC05' }}>o</span>
            <span style={{ color: '#4285F4' }}>g</span>
            <span style={{ color: '#34A853' }}>l</span>
            <span style={{ color: '#EA4335' }}>e</span>
          </Text>
          {error && <Text color="red.300" fontSize="xs" pt={1}>{error}</Text>}
        </VStack>
      </Box>
    </Box>
  )
}

export default LoginScreen
